import React from 'react';
import {
  BabyCarriageStoragePictogram,
  BikeStoragePictogram,
  BookNoticePictogram,
  BookPictogram,
  ClubRoomPictogram,
  ComputerPictogram,
  DryingRoomPictogram,
  GlovesPictogram,
  HousingQuestionsPictogram,
  LaundryPictogramPictogram,
  LockerRoomPictogram,
  MailPictogram,
  MeetingPictogram,
  MegaphonePictogram,
  NotepadPictogram,
  NotUrgentPictogram,
  PartyPictogram,
  PersonalStoragePictogram,
  SaunaPictogram,
  UrgentPictogram,
  WasteRoomPictogram,
  PdfIcon,
} from '../../assets';

export type PictogramName =
  | 'mail'
  | 'babyCarriageStorage'
  | 'bikeStorage'
  | 'book'
  | 'bookNotice'
  | 'clubRoom'
  | 'computer'
  | 'dryingRoom'
  | 'gloves'
  | 'housingQuestions'
  | 'laundry'
  | 'lockerRoom'
  | 'mail'
  | 'meeting'
  | 'megaphone'
  | 'notUrgent'
  | 'notepad'
  | 'party'
  | 'pdf'
  | 'personalStorage'
  | 'sauna'
  | 'urgent'
  | 'wasteRoom';

const getPictogram = (pictogram: PictogramName) => {
  const pictograms: Record<PictogramName, React.FC<React.SVGProps<SVGSVGElement>>> = {
    babyCarriageStorage: BabyCarriageStoragePictogram,
    bikeStorage: BikeStoragePictogram,
    book: BookPictogram,
    bookNotice: BookNoticePictogram,
    clubRoom: ClubRoomPictogram,
    computer: ComputerPictogram,
    dryingRoom: DryingRoomPictogram,
    gloves: GlovesPictogram,
    housingQuestions: HousingQuestionsPictogram,
    laundry: LaundryPictogramPictogram,
    lockerRoom: LockerRoomPictogram,
    mail: MailPictogram,
    meeting: MeetingPictogram,
    megaphone: MegaphonePictogram,
    notUrgent: NotUrgentPictogram,
    notepad: NotepadPictogram,
    party: PartyPictogram,
    pdf: PdfIcon,
    personalStorage: PersonalStoragePictogram,
    sauna: SaunaPictogram,
    urgent: UrgentPictogram,
    wasteRoom: WasteRoomPictogram,
  };

  return pictograms[pictogram];
};
type Props = {
  name: PictogramName;
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
};

const Pictogram = ({ name, width = '96px', height = '96px' }: Props) => {
  const PictogramToShow = getPictogram(name);
  return <PictogramToShow width={width} height={height} />;
};

export default Pictogram;
